module.exports = __webpack_public_path__ + "static/img/thumb_22.0b5b9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_22.png
// module id = buOu
// module chunks = 0